module.exports = __webpack_public_path__ + "img/boy-normal.8e5c4316.gif";